import apiClient from './apiClient';

export interface DriverTimeoutSettings {
  hourly_timeout_minutes: number;
  daily_timeout_minutes: number;
}

export interface DriverTimeoutResponse {
  success: boolean;
  data: DriverTimeoutSettings;
}

export const driverSettingsService = {
  /**
   * Get current driver timeout settings
   */
  getTimeoutSettings: async (): Promise<DriverTimeoutResponse> => {
    const response = await apiClient.get('/api/admin/settings/driver-timeout');
    return response.data;
  },

  /**
   * Update driver timeout settings
   */
  updateTimeoutSettings: async (data: DriverTimeoutSettings): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.post('/api/admin/settings/driver-timeout', data);
    return response.data;
  },
};
